<template>
  <!-- timeline icon -->
  <slot name="icon">
    <WTimelineIcon :icon="props.icon" :color="props.iconColor" />
  </slot>

  <!-- header section -->
  <div class="header">
    <slot name="header">
      <span class="header-title">{{ props.title }}</span>
    </slot>
  </div>

  <template v-if="hasBody">
    <!-- side border -->
    <div></div>

    <!-- body section -->
    <div class="body">
      <slot name="body">
        <span class="body-content">{{ props.description }}</span>
      </slot>
    </div>
  </template>
</template>

<script setup lang="ts">
  import { computed, useSlots } from 'vue';
  import WTimelineIcon from './WTimelineIcon.vue';

  const props = defineProps<{
    icon?: string;
    iconColor?: 'light' | 'primary' | 'secondary' | 'danger';
    title?: string;
    description?: string;
  }>();

  const $slots = useSlots();
  const hasBody = computed(() => $slots['body'] || props.description !== undefined);
</script>

<style scoped lang="scss">
  @import '@/assets/styles/variables';

  .header,
  .body {
    font-size: 0.875rem;
    align-self: center;
    color: $neutral-black;
  }

  .header-title {
    font-weight: 500;
  }

  .body {
    font-weight: 400;
  }
</style>
